import React from "react";
import Button from "@mui/material/Button";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

import { formatShortDate } from "../../common/utils";

function AdminEngagementsTableRow(props: any) {
  const {
    engagement,
    endEngagement,
    navigateToAdminEngagementsViewPage,
    lastTimesheetSubmittedAt,
  } = props;

  return (
    <TableRow
      sx={{ cursor: "pointer" }}
      key={engagement.id}
      onClick={() => navigateToAdminEngagementsViewPage(engagement.id)}
    >
      <TableCell component="th" scope="row">
        {engagement.clientName}
      </TableCell>
      <TableCell>
        {engagement.user.firstName} {engagement.user.lastName}
      </TableCell>
      <TableCell>{engagement.currency}</TableCell>
      <TableCell>{engagement.hourlyRate}</TableCell>
      <TableCell>{engagement.trackingType}</TableCell>
      <TableCell>{engagement.numberOfHoursPerWeek}</TableCell>
      <TableCell>{engagement.shortDescription}</TableCell>
      <TableCell>{engagement.description}</TableCell>
      <TableCell>{formatShortDate(lastTimesheetSubmittedAt)}</TableCell>
      <TableCell>{formatShortDate(engagement.startDate)}</TableCell>
      <TableCell>
        {engagement.endDate ? (
          formatShortDate(engagement.endDate)
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={(e: any) => {
              e.stopPropagation();
              endEngagement(engagement.publicId);
            }}
          >
            End Engagement
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
}

export default AdminEngagementsTableRow;
